import React from "react";
import "./style.css";
import Ink from "react-ink";


export default function SelectButton({
  text = "Select Button",
  containerStyles = {},
  textStyles = {},
  disabled = false,
  active = false,
  containerClasses = "",
  textClasses = "",
  onClick = function() {}
}) {
  const determineStyles = type => {
    if (type === "container") {
      return disabled || !active
        ? `select-button-container notselected-select-button-container ${disabled &&
            "disabled-select-button-container"} ${containerClasses}`
        : `select-button-container ${containerClasses}`;
    }

    if (type === "text") {
      return disabled || !active
        ? `select-button-text notselected-select-button-text ${textClasses}`
        : `select-button-text ${textClasses}`;
    }
  };

  if (disabled) containerStyles.cursor = "disabled";

  return (
    <div
      onClick={onClick}
      className={determineStyles("container")}
      style={containerStyles}
    >
      <p className={determineStyles("text")} style={textStyles}>
        {text}
      </p>
      {!disabled && <Ink />}
    </div>
  );
}
